/**
 * Signature re-capture — submit callable (PF-6119).
 *
 * The server is the authoritative ink gate; the page's live check only drives the button. The
 * request and response shapes come from `@physiofit-digital/physiofit_types`, so this wrapper cannot
 * drift from the function it calls.
 */
import type {
  SubmitSignatureRecaptureRequest,
  SubmitSignatureRecaptureResponse,
} from '@physiofit-digital/physiofit_types';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../firebaseConfig';

export const submitSignatureRecapture = (data: SubmitSignatureRecaptureRequest) =>
  httpsCallable<SubmitSignatureRecaptureRequest, SubmitSignatureRecaptureResponse>(
    functions,
    'submitSignatureRecapture',
  )(data).then((r) => r.data);
